<div
  class="chatbot-thinking"
  [class.is-active]="isActive"
  [class.is-expanded]="expanded"
  [class.is-settled]="!isActive"
>
  <div class="chatbot-thinking__card">
    <button
      type="button"
      class="chatbot-thinking__trigger"
      [attr.aria-expanded]="expanded"
      (click)="toggleExpanded($event)"
    >
      <svg
        class="chatbot-thinking__spark"
        width="15"
        height="15"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"
          fill="currentColor"
        />
      </svg>

      <span class="chatbot-thinking__status" role="status">
        <span
          class="chatbot-thinking__label"
          [class.is-shimmer]="isActive"
        >{{ headerLabel }}</span>
      </span>

      <svg
        class="chatbot-thinking__chevron"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M6 9l6 6 6-6" />
      </svg>
    </button>

    <div class="chatbot-thinking__body" [class.is-open]="expanded">
      <div class="chatbot-thinking__bodyInner">
        <div class="chatbot-thinking__railWrap">
          <span class="chatbot-thinking__rail" aria-hidden="true"></span>

          <ul class="chatbot-thinking__rows" aria-label="Pensamento">
            <li
              *ngFor="let row of rows; trackBy: trackRow"
              class="chatbot-thinking__row"
              [class.chatbot-thinking__row--search]="row.kind === 'search'"
              [class.chatbot-thinking__row--tool]="row.kind === 'tool'"
              [class.chatbot-thinking__row--reasoning]="row.kind === 'reasoning'"
              [class.is-current]="row.isCurrent"
            >
              <span
                *ngIf="row.kind === 'search'"
                class="chatbot-thinking__siteIcon"
                [class.is-current]="row.isCurrent"
                aria-hidden="true"
              >
                <img
                  *ngIf="siteFavicon(row) as favicon; else siteIconFallback"
                  class="chatbot-thinking__siteFavicon"
                  [src]="favicon"
                  alt=""
                  width="18"
                  height="18"
                  loading="lazy"
                  decoding="async"
                  (error)="onSiteFaviconError(row)"
                />
                <ng-template #siteIconFallback>
                  <span class="material-symbols-outlined">language</span>
                </ng-template>
              </span>
              <span
                *ngIf="row.kind === 'tool'"
                class="chatbot-thinking__siteIcon chatbot-thinking__siteIcon--wosi"
                [class.is-current]="row.isCurrent"
                aria-hidden="true"
              >
                <img
                  class="chatbot-thinking__siteFavicon"
                  [src]="wosiMarkSrc"
                  alt=""
                  width="18"
                  height="18"
                  loading="lazy"
                  decoding="async"
                />
              </span>
              <span
                *ngIf="!isInlineActionRow(row)"
                class="chatbot-thinking__marker"
                aria-hidden="true"
              >
                <span *ngIf="row.isCurrent" class="chatbot-thinking__spinner"></span>
                <svg
                  *ngIf="!row.isCurrent"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </span>
              <span class="chatbot-thinking__copy">
                <ng-container *ngIf="isInlineActionRow(row); else stepCopy">
                  <a
                    *ngIf="row.kind === 'search' && row.href; else inlineActionPlain"
                    class="chatbot-thinking__searchLink"
                    [href]="row.href"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="$event.stopPropagation()"
                  >
                    <span class="chatbot-thinking__searchTitle">{{ row.primary }}</span>
                    <span
                      *ngIf="row.secondary"
                      class="chatbot-thinking__searchHost"
                    >{{ row.secondary }}</span>
                  </a>
                  <ng-template #inlineActionPlain>
                    <span class="chatbot-thinking__searchLink">
                      <span class="chatbot-thinking__searchTitle">{{ row.primary }}</span>
                      <span
                        *ngIf="row.secondary"
                        class="chatbot-thinking__searchHost"
                      >{{ row.secondary }}</span>
                    </span>
                  </ng-template>
                </ng-container>
                <ng-template #stepCopy>
                  <span class="chatbot-thinking__primary">{{ row.primary }}</span>
                  <span
                    *ngIf="row.secondary"
                    class="chatbot-thinking__secondary"
                  >{{ row.secondary }}</span>
                </ng-template>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
